'use strict';

var React = require('react');
var PropTypes = React.PropTypes;


var cardDrawer = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  content: PropTypes.any.isRequired
});

var cardDrawers = PropTypes.arrayOf(cardDrawer);

module.exports = {
  cardDrawer: cardDrawer,
  cardDrawers: cardDrawers
};